module.exports = __webpack_public_path__ + "img/xp_bar_expert.de27974a.svg";